<div class="d-flex gap-3">
	<div class="col-6 col-lg-2 form-group">
		<label>{{ "name" | langVal }}</label>
		<app-gen-input
			[actualObj]="prescriptionObj"
			fieldName="patient_name"
			[errors]="errors"
			title_ph_lang="name"
			(keyupEvent)="validateEntireForm()"
		/>
	</div>
	<div class="col-6 col-lg-2 form-group">
		<label>{{ "id_number" | langVal }}</label>
		<app-gen-input
			[actualObj]="prescriptionObj"
			fieldName="patient_id_number"
			[errors]="errors"
			title_ph_lang="id_number"
			(keyupEvent)="validateEntireForm()"
		/>
	</div>
	<div class="col-6 col-lg-2 form-group">
		<label>{{ "address" | langVal }}</label>
		<app-gen-input
			[actualObj]="prescriptionObj"
			fieldName="address"
			[errors]="errors"
			(keyupEvent)="validateEntireForm()"
		/>
	</div>
	<div class="col-6 col-lg-2 form-group">
		<label>{{ "age" | langVal }}</label>
		<app-gen-input
			disabled
			[actualObj]="prescriptionObj"
			fieldName="age"
		/>
	</div>
	<div class="col-6 col-lg-2 form-group">
		<label>{{ "date" | langVal }}</label>
		<app-date-picker
			#Date
			[actualObj]="prescriptionObj"
			fieldName="date"
			[addonObject]="{ after: { icon: 'calendar' } }"
		/>
	</div>
</div>
<div
	style="direction: ltr; text-align: left"
	dir="ltr"
>
	<div class="table-responsive">
		<table class="table table-hover table-striped pad-block">
			<thead>
				<tr>
					<th>
						<app-check
							(onClick)="
								chooseAllChecked = !chooseAllChecked;
								chooseAll(chooseAllChecked)
							"
							[isCheck]="chooseAllChecked"
						/>
					</th>
					@for (
						field of [
							"dosage_form",
							"medic",
							"amount_output",
							"route_of_admin",
							"total_amount",
							"remarks",
						];
						track field
					) {
						<th>{{ field | langVal }}</th>
					}
				</tr>
			</thead>
			<tbody>
				@for (row of medicpatients; track row) {
					<tr>
						<td>
							<app-check
								(onClick)="handleCheck(row)"
								[isCheck]="row.checked"
							/>
						</td>

						<td>{{ row.dosage_form }}</td>
						<td>{{ row.medic_name }}</td>
						<td class="colstat colstat-small">{{ row.amount_output }}</td>
						<td class="colstat colstat-price">{{ row.route_of_admin }}</td>
						<td>
							<app-gen-input
								className="colstat colstat-price"
								[actualObj]="row"
								isNumber
								[errors]="row.errors"
								fieldName="total_amount"
								(changeEvent)="handleAmountChange()"
								(keyupEvent)="handleAmountChange()"
							/>
						</td>
						<td>
							<app-gen-input
								className="colstat colstat-small-triple"
								[actualObj]="row"
								fieldName="remarks"
								(changeEvent)="validateEntireForm()"
							/>
						</td>
					</tr>
				}
			</tbody>
		</table>
	</div>
	<div class="row">
		<div class="col-12 form-group">
			<label>{{ "remarks" | langVal }}</label>
			<app-wysiwyg
				[actualObj]="prescriptionObj"
				fieldName="remarks"
			/>
		</div>
	</div>
	@if (isDrug) {
		<div class="row">
			<div class="col-12 form-group">
				<label>{{ "permanent_remarks" | langVal }}</label>
				<app-wysiwyg
					#permanentRemarksWysiwyg
					[actualObj]="prescriptionObj"
					fieldName="permanent_remarks"
				/>
			</div>
		</div>
	}
</div>

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<app-btn-ext
		[disabled]="!isFormSubmittable"
		(clickEv)="isGetHeadtureOpen = true"
		text="to_preview"
		[isSpin]="isInPreview || isGetHeadtureOpen"
	/>
</div>
@if (modalProps) {
	<app-preview-finresource
		(onClose)="modalProps = null; closeIfValue($event)"
		[headtureRow]="modalProps.headtureRow"
		[finresourceObj]="modalProps.finresourceObj"
		doctype="prescription"
	/>
}
@if (isGetHeadtureOpen) {
	<app-get-headture-row
		isPrescription
		(onDone)="isGetHeadtureOpen = false; $event && handleGetHeadtureRow($event)"
	/>
}
